export default class NonJeffersonian {
    id: number;
    nonJeffersonianTownshipId: number;
    areaNumber?: number;
    abstract: string;
    survey: string;
    sectionSurveyType: string;
    block: string;
    // township: number;
    section: number;
    fraction: number;
    tsdNo: number;
    tsdName: string;
}



// WEBPACK FOOTER //
// ./src/models/projectSettings/subCode/section_types/NonJeffersonian.ts